<template>
  <div>
    <!--filter-->
    <div class="row">
      <div class="col-6 col-sm-8 col-md-9 col-lg-9 col-xl-9">
        <div
          v-if="options.showFilter"
          class="filters-wrapper d-flex justify-content-start flex-wrap"
        >
          <!--Open Filters Button For Mobile-->
          <button
            class="btn d-block d-sm-none btn-toggle-filters"
            type="button"
            @click.prevent="toggleFilters"
          >
            <app-icon :name="'filter'" />
            {{ $t("filters") }}
          </button>

          <span v-show="isFiltersOpen" class="mobile-filters-wrapper">
            <app-filter
              :filters="options.filters"
              @get-values="getFilterValues"
            />

            <button
              type="button"
              class="btn btn-primary btn-with-shadow d-sm-none btn-close-filter-wrapper d-flex justify-content-center align-items-center"
              @click="toggleFilters"
            >
              {{ $t("close") }}
            </button>
          </span>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-md-3 col-lg-3 col-xl-3">
        <div
          v-if="options.showSearch"
          class="mr-0 single-filter single-search-wrapper"
        >
          <div
            class="form-group form-group-with-search d-flex align-items-center justify-content-end"
          >
            <app-search @input="getSearchValue" />
          </div>
        </div>
      </div>
    </div>

    <!--calendar-->
    <div class="card card-with-shadow border-0">
      <div class="calendar-view">
        <div class="card-body p-primary">
          <component
            :is="'full-calendar'"
            ref="fullCalendar"
            v-if="!filterChanged"
            :changeView="viewChange()"
            :header="header"
            :plugins="calendarPlugins"
            :events="options.events"
            :views="views"
            :selectable="true"
            :defaultView="initialView"
            @_eventsPositioned="setView"
            @eventClick="selectedEventHandle"
            @select="handleClick"
            :defaultDate="initialDate"
          />
          <app-overlay-loader v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@core/mixins/form/FormMixin";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

export default {
  name: "AppCalendar",
  components: { FullCalendar },
  mixins: [FormMixin],
  props: {
    options: {
      type: Object,
    },
  },
  data() {
    return {
      // For Plugins
      calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      header: {
        left: "title",
        center: "prev today next",
        right: "dayGridMonth,timeGridWeek,timeGridDay",
      },
      initialView: 'dayGridMonth',
      views: {
        dayGridMonth: {
          titleFormat: {month: 'long', year: 'numeric'},
          columnHeaderFormat: {
            weekday: 'short'
          }
        },
        timeGridWeek: {
          titleFormat: {month: 'long', year: 'numeric'},
          columnHeaderHtml: function (date) {
            if (date.getDay() === 1) {
              let day = date.getDate();
              return '<div class="fc-calendar-date-name">Mon</div><div class="fc-calendar-day-name">' + day + '</div>';
            } else if (date.getDay() === 2) {
              let day = date.getDate();
              return '<div class="fc-calendar-date-name">Tue</div><div class="fc-calendar-day-name">' + day + '</div>';
            } else if (date.getDay() === 3) {
              let day = date.getDate();
              return '<div class="fc-calendar-date-name">Wed</div><div class="fc-calendar-day-name">' + day + '</div>';
            } else if (date.getDay() === 4) {
              let day = date.getDate();
              return '<div class="fc-calendar-date-name">Thu</div><div class="fc-calendar-day-name">' + day + '</div>';
            } else if (date.getDay() === 5) {
              let day = date.getDate();
              return '<div class="fc-calendar-date-name">Fri</div><div class="fc-calendar-day-name">' + day + '</div>';
            } else if (date.getDay() === 6) {
              let day = date.getDate();
              return '<div class="fc-calendar-date-name">Sat</div><div class="fc-calendar-day-name">' + day + '</div>';
            } else {
              let day = date.getDate();
              return '<div class="fc-calendar-date-name">Sun</div><div class="fc-calendar-day-name">' + day + '</div>';
            }
          },
          weekNumbers: true
        },
        timeGridDay: {
          titleFormat: {day: 'numeric', month: 'long', year: 'numeric'},
          columnHeaderFormat: {
            weekday: 'long'
          }
        }
      },
      // For filter
      isFiltersOpen: true,
      filterValue: {},
      filterChanged: false,
      initialDate: new Date(),
    };
  },
  mounted() {
    this.isFiltersActive();
    window.onresize = () => {
      this.isFiltersActive();
    };
    this.setInitialView();
  },
  methods: {
    handleClick(arg) {
      this.$emit("select", arg);
    },
    selectedEventHandle(arg) {
      this.$emit("eventClick", arg);
    },
    //for filter
    getFilterValues(values) {
      this.setInitialView();
      
      if(!values['done_activity']){
        values['done_activity'] = null
      }
      this.filterValue = values;
      this.$emit("trigger-filter", this.filterValue);
      this.filterChanged = true;
      
      if (values["schedule"]) {
        this.initialDate = values.schedule.start;
      }
      
      // let urlParam = new URLSearchParams(values).toString();
      // this.axiosGet("crm/activities?" + urlParam)
      //   .then((res) => {
      //     // console.log(res);
      //     this.options.events = [];
      //     res.data.forEach((el) => {
      //       let arr = el.contextable_type
      //         ? el.contextable_type.split("\\")
      //         : [];
      //       let doneClassName = el.status_id == 10 ? 'done':'todo';
      //       this.options.events.push({
      //         title: el.title,
      //         className: [el.activity_type.name.toLowerCase(), doneClassName],
      //         start: el.started_at + " " + el.start_time,
      //         end: el.ended_at + " " + el.end_time,
      //         contextableType: arr[arr.length - 1],
      //         activityType: el.activity_type.name,
      //         databaseId: el.id,
      //         status_id:el.status_id,
      //         activity_type_id:el.activity_type_id
      //       });
      //     });
      //     setTimeout(() => {
      //       this.filterChanged = false;
      //     }, 500);
      //   })
      //   .catch((er) => console.log(er.message));

       setTimeout(() => {
            this.filterChanged = false;
          }, 500);
      
    },
    toggleFilters() {
      this.isFiltersOpen = !this.isFiltersOpen;
    },
    getSearchValue(value) {
      this.filterValue.search = value;
      this.$emit("trigger-filter", this.filterValue);
    },
    isFiltersActive() {
      this.isFiltersOpen = window.innerWidth > 575;
    },
    viewChange(v){
      // console.log(v,'view')
    },


    setView(){
      $('.fc-dayGridMonth-button').click(()=> {
          localStorage.setItem('calendar-default-view','dayGridMonth');
      });
      $('.fc-timeGridWeek-button').click(()=> {
        localStorage.setItem('calendar-default-view','timeGridWeek');
      });
      $('.fc-timeGridDay-button').click(()=> {
        localStorage.setItem('calendar-default-view','timeGridDay');
      })
    },
    setInitialView(){
      let x = localStorage.getItem("calendar-default-view");
      if(x){
        this.initialView = x;
      }
    }
  },
};
</script>
<style>
.calendar-view .fc-dayGridMonth-view .fc-today {
    background: #f0f3ff6b !important;
}
.calendar-view .fc-event{
  color: #6f6f6f !important;
  cursor: pointer !important;
  box-shadow: none !important;
}
.calendar-view .fc-event.meeting {
  background: #ddf3bc !important;
}

.calendar-view .fc-event.email {
  background: #c4ced6 !important;
}

.calendar-view .fc-event.call {
  background: #fbc5c5 !important;
}

.calendar-view .fc-event.task {
  background: #e5e69f !important;
}

.calendar-view .fc-event.deadline {
  background: #a9e8f7 !important;
}

.calendar-view .fc-event.lunch {
  background: #e0d420 !important;
}
.calendar-view .fc-event.done {
    text-decoration: line-through !important;
}
</style>

